import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 640 640",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 640\" id=\"arrow-left\">\n<path d=\"M598.191 0l0.069 639.999-556.521-320z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol